import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  baseURL="http://localhost:9091/Post";
  constructor(private posthttp:HttpClient) { }

    getPostByUserId(id:any):Observable<any>{
      return this.posthttp.get<any>(this.baseURL +"/getByUserId/"+id);
    }

    getAllPost(): Observable<any> {
      return this.posthttp.get(this.baseURL + "/getAll");
    }
  
    addPost(post: any, id: any): Observable<any> {
  
      return this.posthttp.post<any>(this.baseURL + "/addPost/" + id, post);
    }

    addPost2(post:any  , id:any , image:File ):Observable<any>{
      const formData = new FormData();
  formData.append("title", post.titre);
  formData.append("description", post.description);
  formData.append("email", post.email);
  formData.append("numtlf", post.numtlf);
  /*formData.append("fb",post.fb);
  formData.append("insta",post.insta);
  formData.append("tiktok",post.tiktok);
  formData.append("linked",post.linked);*/
  formData.append("price",post.price);
  formData.append("state",post.state);
  formData.append("pricePerHour",post.pricePerHour);
  formData.append("experience",post.experience);
  formData.append("impact",post.impact);
  formData.append("mainGoal",post.mainGoal);
  formData.append("image", image);
  return this.posthttp.post<any>(`${this.baseURL}/addPost2/${id}`, formData);
    }

    ajouterPost(post: any, id: any): Observable<any> {

      return this.posthttp.post<any>(this.baseURL + "/ajouterPost/" + id, post);
    }
  
    deletePost(id: any): Observable<any> {
      return this.posthttp.delete(this.baseURL + "/delete/" + id);
    }
  
    getPostById(id: any): Observable<any> {
      return this.posthttp.get<any>(this.baseURL + "/getById/" + id);
    }

    
  
    countPostByIdUser(id: any): Observable<any> {
      return this.posthttp.get(this.baseURL + "/CountPostByIdUser/" + id);
    }
  
    countPost(): Observable<any> {
      return this.posthttp.get(this.baseURL + "/CountPost");
    }
  
    likePost(id: any): Observable<any> {
      return this.posthttp.put<any>(this.baseURL + "/LikePost/" + id, null);
    }
    disLikePost(id: any): Observable<any> {
      return this.posthttp.put<any>(this.baseURL + "/disLikePost/" + id, null);
    }
    addImage(file: any, id: any): Observable<any> {
      return this.posthttp.put<any>(this.baseURL + "/Image/" + id, file);
    }
  
    masquerPost(id: any): Observable<any> {
      return this.posthttp.put(this.baseURL + "/masquer/" + id, null);
    }
  


    updatePost(id: any, post: any, image: File): Observable<any> {
      const formData = new FormData();
      formData.append("titre", post.titre);
      formData.append("description", post.description);
      formData.append("email", post.email);
      formData.append("numtlf", post.numtlf);
      formData.append("fb", post.fb);
      formData.append("insta", post.insta);
      formData.append("tiktok", post.tiktok);
      formData.append("linked", post.linked);
      formData.append("ba9chich", post.ba9chich);
      formData.append("image", image);
    
      return this.posthttp.put(`${this.baseURL}/update/${id}`, formData);
    }
    

/*
    updatePost(id: any, post: any,image:File): Observable<any> {
      return this.posthttp.put(this.baseURL + "/update/" + id, post);
    }
*/
}
